/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
function getFilteredSizes() {
    const params = new URLSearchParams(window.location.search);
    const sizes = [];
    for (const [key, value] of params.entries()) {
      if (key === 'filter.p.option.taille') {
        sizes.push(value.toLowerCase());
      }
    }
    return sizes;
  }

  function hideUnavailableProducts(filteredSizes) {
    if (filteredSizes.length === 0) return;

    document.querySelectorAll('grid-item').forEach((card) => {
      const scriptTag = card.querySelector('script[data-variants-json]');
      if (!scriptTag) return;

      let variants;
      try {
        variants = JSON.parse(scriptTag.textContent);
      } catch (e) {
        return;
      }

      const hasAvailableSize = variants.some((variant) => {
        const taille = variant.options?.[0]?.toLowerCase();
        return taille && filteredSizes.includes(taille) && variant.available;
      });

      if (!hasAvailableSize) {
        card.style.display = 'none';
      }
    });
  }

  function init() {
    const filteredSizes = getFilteredSizes();
    if (filteredSizes.length === 0) return;

    hideUnavailableProducts(filteredSizes);

    const grid = document.querySelector('[data-products-grid]');
    if (grid) {
      const observer = new MutationObserver(() => {
        hideUnavailableProducts(filteredSizes);
      });
      observer.observe(grid, { childList: true, subtree: true });
    }
  }

  document.addEventListener('DOMContentLoaded', init);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
